import { render, staticRenderFns } from "./suggestion.vue?vue&type=template&id=2fceb81f&scoped=true"
import script from "./suggestion.vue?vue&type=script&lang=js"
export * from "./suggestion.vue?vue&type=script&lang=js"
import style0 from "./suggestion.vue?vue&type=style&index=0&id=2fceb81f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fceb81f",
  null
  
)

export default component.exports